import React from "react";
import { FEE_TIERS, activeTierForCamp } from "@/components/camps/campConfig";

const FeeRow = ({ c, tier, price, isActive }) => (
  <div className={`flex items-start justify-between gap-4 ${isActive ? "" : "opacity-45"}`}>
    <div className="flex-1 min-w-0">
      <div className="text-[#5E6470] text-[13px] flex items-center gap-2">
        <span>{c.feeTiers[tier]}</span>
        {isActive && (
          <span className="text-[9px] tracking-[0.24em] uppercase font-bold text-[#C4A46A] border border-[#C4A46A]/60 px-1.5 py-[1px]">
            ●
          </span>
        )}
      </div>
      {c.feeTierDates?.[tier] && (
        <div className="mt-0.5 text-[11px] italic text-[#5E6470]/80">{c.feeTierDates[tier]}</div>
      )}
    </div>
    <div className="font-display text-lg text-[#0F1B2D] tabular-nums shrink-0">${price}</div>
  </div>
);

export const CampFees = ({ c, camp }) => {
  const active = activeTierForCamp(camp.slug);
  return (
    <div className="mt-8 pt-6 border-t border-[#0F1B2D]/10" data-testid={`camp-fees-${camp.slug}`}>
      <div className="overline text-[#0F1B2D]">{c.feesLabel}</div>
      <dl className="mt-4 space-y-3">
        {FEE_TIERS.map((tier) => (
          <FeeRow key={tier} c={c} tier={tier} price={camp.fees[tier]} isActive={active === tier} />
        ))}
      </dl>
    </div>
  );
};
